<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<section epub:type="dedication" role="doc-dedication">
<p class="DED" id="ded"><span aria-label="5" id="pg_5" role="doc-pagebreak"><i>To loved ones lost, in the hope that they still hear the stories you never got to share.</i></span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?c5c7070a